import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <CarouselSection />
        <MediaSection />
        <CommentsSection />
        <RankingSection />
        <TopicsSection />
        <FAQSection />
        <AppSection />
        <CardsSection />
        <FeaturesSection />
        <ContactSection />
        <IndexSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}